import CandidateMatchScoresScreen from 'pages/iPriseV2/common/candidate-match-scores';
import Teams from 'pages/iPriseV2/common/teams';
import TeamDetail from 'pages/iPriseV2/common/teams/team-detail';
import ViewCandidate from 'pages/iPriseV2/common/view-candidate';
import ViewJobV2 from 'pages/iPriseV2/common/view-job';
import ViewMatchedCandidate from 'pages/iPriseV2/common/view-matched-candidate';
import Candidates from 'pages/iPriseV2/manager/candidates';
import JobQueue from 'pages/iPriseV2/manager/job-queue';
import Header from 'pages/iPriseV2/manager/layout/Header';
import ManagerProfile from 'pages/iPriseV2/manager/profile';
import Reports from 'pages/iPriseV2/manager/reports';
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

const ManagerRoutes = () => {
  return (
    <Routes>
      <Route path="manager" element={<Header />}>
        <Route index element={<Navigate to="job-queue" replace />} />
        <Route path="job-queue" element={<JobQueue />} />
        <Route path="view-job/:id" element={<ViewJobV2 />} />
        <Route
          path="view-matched-candidate"
          element={<ViewMatchedCandidate />}
        />
        <Route
          path="view-matched-candidate-scores"
          element={<CandidateMatchScoresScreen />}
        />
        <Route path="view-candidate/:candidateId" element={<ViewCandidate />} />
        <Route path="candidates" element={<Candidates />} />
        <Route path="teams" element={<Teams />} />
        <Route path="team/:id" element={<TeamDetail />} />
        <Route path="reports" element={<Reports />} />
        <Route path="profile" element={<ManagerProfile />} />
      </Route>
      {/* Redirect any unknown route to manager/job-queue */}
      <Route path="*" element={<Navigate to="manager/job-queue" replace />} />
    </Routes>
  );
};

export default ManagerRoutes;
